import { render, staticRenderFns } from "./dealer-successfully.vue?vue&type=template&id=2c1ba183&scoped=true&"
import script from "./dealer-successfully.vue?vue&type=script&lang=js&"
export * from "./dealer-successfully.vue?vue&type=script&lang=js&"
import style0 from "./dealer-successfully.vue?vue&type=style&index=0&id=2c1ba183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ba183",
  null
  
)

export default component.exports